// extracted by mini-css-extract-plugin
export default {"container":"detail_container__FgZOu","biblio":"detail_biblio__2uvOs"};